var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCpra32Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lm-Icon",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H8C3.58 8 0 11.58 0 16C0 20.42 3.58 24 8 24H24C28.42 24 32 20.42 32 16C32 11.58 28.42 8 24 8ZM26.44 18.3133C26.6333 18.5067 26.6333 18.8267 26.44 19.02C26.34 19.12 26.2133 19.1667 26.0867 19.1667C25.96 19.1667 25.8333 19.12 25.7333 19.02L23.42 16.7067L21.1067 19.02C21.0067 19.12 20.88 19.1667 20.7533 19.1667C20.6267 19.1667 20.5 19.12 20.4 19.02C20.2067 18.8267 20.2067 18.5067 20.4 18.3133L22.7133 16L20.4 13.6867C20.2067 13.4933 20.2067 13.1733 20.4 12.98C20.5933 12.7867 20.9133 12.7867 21.1067 12.98L23.42 15.2933L25.7333 12.98C25.9267 12.7867 26.2467 12.7867 26.44 12.98C26.6333 13.1733 26.6333 13.4933 26.44 13.6867L24.1267 16L26.44 18.3133ZM8 23C4.14 23 1 19.86 1 16C1 12.14 4.14 9 8 9H18.2533L12.42 23H8.00667H8ZM12.88 13.6867L7.19334 19.3733L4.52 16.7C4.32667 16.5067 4.32667 16.1867 4.52 15.9933C4.71334 15.8 5.03333 15.8 5.22667 15.9933L7.19334 17.96L12.1733 12.98C12.3667 12.7867 12.6867 12.7867 12.88 12.98C13.0733 13.1733 13.0733 13.4933 12.88 13.6867Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCpra32Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CPRA_32px.42a9d0ca4ece3c2b03088cddb899abb7.svg";